exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdr-custom-button-with-icon .v-icon:before{color:#ab3b7a}.sdr-custom-button-with-icon.v-btn--disabled .v-icon:before{color:#e0e0e0}.v-slider__tick,.v-slider__tick.v-slider__tick--filled{width:7px!important;height:7px!important;border-radius:50%;margin-top:-3px;margin-left:-3px;background:#ab3b7a;cursor:pointer}.v-slider__tick:first-of-type .v-slider__tick-label{transform:translateX(-50%)!important}.v-slider__tick:last-of-type .v-slider__tick-label{transform:translateX(-25%)!important}.theme--light.v-label{color:rgba(0,0,0,.7)}", ""]);

// exports
